import { render, staticRenderFns } from "./IncludeWeekends.vue?vue&type=template&id=839e906a&scoped=true"
import script from "./IncludeWeekends.vue?vue&type=script&lang=js"
export * from "./IncludeWeekends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839e906a",
  null
  
)

export default component.exports